import { ChainId } from '@pancakeswap/chains'

export const AVERAGE_CHAIN_BLOCK_TIMES = {
  [ChainId.PULSECHAIN]: 10,
}
